import { environment } from './environments/environment';
import { configureAmplify } from './app/amplify-configuration';

/** Debe importarse antes que el resto de la app para que las cookies de Cognito coincidan con `fetchAuthSession`. */
configureAmplify(environment.aws);
